import { render, staticRenderFns } from "./UpdatedDetails.vue?vue&type=template&id=61af6736"
import script from "./UpdatedDetails.vue?vue&type=script&lang=js"
export * from "./UpdatedDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports